module.exports = __webpack_public_path__ + "img/nav_item_bg1_no_active.64fadaa6.png";